// extracted by mini-css-extract-plugin
export default {"pdfContainer":"QRCode_pdfContainer__ljM04","qrCodeImage":"QRCode_qrCodeImage__ckYha","qrCode":"QRCode_qrCode__Ud0iA","utmCode":"QRCode_utmCode__q4Osc"};